export enum StateListDocs {
	'Ok'='Ok',
    'Error'='Error',
    'Partial'='Partial',
    'NoState'='NoState'
}